import { useEffect, useState, useRef } from "react";
import { generateFileUrl, userRequest } from "../../requestMethods";
import "../../global.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useCompany } from "../../components/context/CompanyContext";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";

import dayjs from "dayjs";
import { formatPricing, formatPricingDatabase, validarEmail, validarCpfCnpj } from "../../util/helper";
import { resolveLogoForSave, DEFAULT_LOGO } from "../../util/logoHelper";
export default function Company() {
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const [company, setCompany] = useState("");
  const [state, setState] = useState("");
  const [states, setStates] = useState([]);
  const [file, setFile] = useState();
  const [fileList, setFileList] = useState();
  const [inputs, setInputs] = useState();
  const [filesIni, setFilesIni] = useState();
  const [numAddress, setNumAddress] = useState();
  const [complement, setComplement] = useState();
  const [rzSocial, setRzSocial] = useState();
  const [cnpj_cpf, setCnpj_cpf] = useState();
  const [contact, setContact] = useState();
  const [street, setStreet] = useState();
  const [cep, setCep] = useState();
  const [retail, setRetail] = useState();
  const [layout, setLayout] = useState();
  // Valida estoque no carrinho (reduz qtde / remove por estoque). Ausente = ligado.
  const [validateStock, setValidateStock] = useState(true);
  const [district, setDistrict] = useState();
  const [city, setCity] = useState();
  const currentUser = useSelector((state) => state.user.currentUser);
  const inputRef = useRef();
  const inputRefname = useRef("");
  const inputRefcontact = useRef("");
  const inputRefemail = useRef("");
  const inputRefabout = useRef("");
  const inputRefPolicy = useRef("");
  const inputRefMinprd = useRef("");
  const inputRefMinOrder = useRef("");
  const { imgLogo, companyId } = useCompany();

  useEffect(() => {
    if (companyId > 0) {
      getCompany();
      getStates();
    }
  }, [companyId]);

  useEffect(() => {
    if (company) {
      if (company.address) {
        setStreet(company.address.street ? company.address.street : null);
        setNumAddress(
          company.address.numAddress ? company.address.numAddress : null
        );
        setComplement(
          company.address.complement ? company.address.complement : null
        );
        setCep(company.address.cep ? company.address.cep : null);
        setState(company.address.state ? company.address.state : null);
        setDistrict(company.address.district ? company.address.district : null);
        setCity(company.address.city ? company.address.city : null);
      }

      if (company.cnpj) {
        setCnpj_cpf(company.cnpj);
      }
      if (company.contact) {
        setContact(company.contact);
      }
      if (company.rzSocial) {
        setRzSocial(company.rzSocial);
      }
      // "defaultLogo.svg" é apenas um placeholder de "sem logo": não deve ser
      // tratado como um arquivo real (evita imagem quebrada e mostra o botão de
      // upload diretamente).
      if (imgLogo && imgLogo !== DEFAULT_LOGO) {
        setFilesIni(true);
        setFile(imgLogo);
      }
      if (company.configUI && company.configUI.isRetail) {
        setRetail(company.configUI.isRetail);
      }
      if (company.configUI && company.configUI.layout) {
        setLayout(company.configUI.layout);
      }
      // Só desliga quando explicitamente false; ausente mantém o padrão (ligado).
      setValidateStock(company.configRules?.validateStock !== false);

    }
  }, [company]);

  const getCompany = async () => {
    try {
      const res = await userRequest.get(`${companyId}/company`);

      setCompany(res.data);
    } catch (error) {}
  };
  const getStates = async () => {
    const res = await userRequest.get(`${companyId}/customers/state`);

    setStates(res.data);
  };
  const handleChangeCNPJ = (e) => {
    if (e.target.value.length === 14) {
      getCNPJ(e.target.value.trim());
    }
  };
  const handleChangeStreet = (e) => {
    setStreet(e.target.value);
  };
  const handleChangeNumAddress = (e) => {
    setNumAddress(e.target.value);
  };
  const handleChangeComplement = (e) => {
    setComplement(e.target.value);
  };

  const handleChangeCity = (e) => {
    setCity(e.target.value);
  };
  const getCep = async (cep) => {
    const res = await userRequest.get(`${companyId}/customers/cep/${cep}`);

    setStreet(res.data.logradouro);
    setCep(cep);
    setState(res.data.uf);
    setDistrict(res.data.bairro);
    setCity(res.data.localidade);
  };
  const getCNPJ = async (cnpj) => {
    const res = await userRequest.get(`${companyId}/customers/cnpj/${cnpj}`);

    setRzSocial(res.data.razao_social);
    setCnpj_cpf(cnpj);
  };

  const validate = () => {
    if (
      inputRefname.current.value === "" ||
      inputRefname.current.value === undefined
    ) {
      return false;
    }
    if (
      inputRefemail.current.value === "" ||
      inputRefemail.current.value === undefined
    ) {
      return false;
    }
    if (!validarEmail(inputRefemail.current.value)) {
      Swal.fire("Atenção!", "E-mail inválido.", "warning");
      return false;
    }
    if (cnpj_cpf === "" || cnpj_cpf === undefined) {
      return false;
    }
    if (!validarCpfCnpj(cnpj_cpf)) {
      Swal.fire("Atenção!", "CPF/CNPJ inválido.", "warning");
      return false;
    }

    if (contact === "" || contact === undefined) {
      return false;
    }
    if (!street || street === "" || street === undefined) {
      return false;
    }
    if (!cep || cep === "" || cep === undefined) {
      return false;
    }
    if (!state || state === "" || state === undefined) {
      return false;
    }
    if (!state) {
      return false;
    }
    return true;
  };
  const updateClick = async (event) => {
    let uploadedLogo = null;
    if (!filesIni) {
      if (fileList && fileList.length === 1) {
        uploadedLogo = await handleUpload();
        if (!uploadedLogo) {
          Swal.fire("Atenção!", "Erro ao enviar o logo!", "error");
          return;
        }
      } else if (fileList && fileList.length > 1) {
        Swal.fire("Atenção!", "Você pode ter apenas 1 logo!", "warning");
        return;
      }
      // sem novo arquivo de logo selecionado: segue salvando os demais dados
    }
    Update(uploadedLogo);
  };
  const Update = async (uploadedLogo) => {
    try {
      const res = await userRequest.put(`${companyId}/company/`, {
        name: inputRefname.current.value,
        cnpj: cnpj_cpf,
        rzSocial: rzSocial,
        contact: contact,
        email: inputRefemail.current.value,
        lastUserUpdate: currentUser.userId,
        address: {
          street: street,
          numAddress: numAddress,
          complement: complement,
          cep: cep,
          state: state,
          district: district,
          city: city,
        },
        about: inputRefabout.current.value,
        exchangePolicy: inputRefPolicy.current.value,
        configRules: {
          ...(company.configRules ?? {}),
          minProducts: parseInt(inputRefMinprd.current.value),
          minVlrOrder: formatPricingDatabase(inputRefMinOrder.current.value),
          validateStock: validateStock,
        },
        configUI: {
          ...(company.configUI ?? {}),
          imgLogo: resolveLogoForSave(uploadedLogo, imgLogo),
          isRetail: retail,
          layout: layout,
        },
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire(
          "Parabéns!",
          "Dados da empresa alterado com sucesso!",
          "success"
        );
      } else {
        Swal.fire("Atenção!", "Erro ao alterar dados!", "error");
      }
    } catch (error) {
      Swal.fire("Atenção!", "Erro ao alterar dados!", "error");
    }
  };

  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const handleChangeState = (e) => {
    setState(e.target.value);
  };
  const handleOnclick = (event) => {
    event.preventDefault();
    inputRef.current.click();
  };
  const handleUpload = async (event) => {
    const formData = new FormData();

    if (fileList && fileList.length > 0) {
      for (var i = 0; i < fileList.length; i++) {
        const photo = fileList[i];
        formData.append("image", photo);
      }
    }
    try {
      const res = await userRequest.post(
        `${companyId}/products/images/logo`,
        formData
      );
      // Backend retorna as imagens enviadas em `imageUrls`; usamos esse valor
      // no PUT /company para persistir o logo correto (e não o valor obsoleto
      // do contexto). Retorna null em falha para abortar o save.
      if (res.status === 200) {
        return res.data && res.data.imageUrls ? res.data.imageUrls : [];
      }
      return null;
    } catch (error) {
      return null;
    }
  };
  const handleOnDelete = (event) => {
    setFilesIni(false);
    setFile();
    setFileList();

    const res = userRequest.delete(`${companyId}/products/images/deletelogo`);

    if (res.status === 200) {
      return true;
    } else {
      return false;
    }
  };
  const handleOnChange = (event) => {
    setFileList(event.target.files);
    Array.from(event.target.files).map((item) => {
      setFile(item);
    });

    setFilesIni(false);
  };
  const handleChangeContact = (e) => {
    setContact(e.target.value);
  };
  const handleChangeRz = (e) => {
    setRzSocial(e.target.value);
  };
  const handleChangeCEP = (e) => {
    const val = e.target.value.trim().replace("-", "");
    setCep(val);
    if (val.length === 8) {
      getCep(val);
    }
  };
  const deleteCashback = async (cp) => {
    const res = await userRequest.put(`${companyId}/cashback/all`, {
      deleted: dayjs(new Date()).format("YYYY-MM-DD"),
      lastUserUpdate: currentUser.userId,
    });
  };
  return (
    <div className="cust-page">
      <div className="cust-title">Dados da Empresa</div>

      {/* Identidade */}
      <div className="cust-card">
        <div className="cust-section-header">Identidade</div>
        <div style={{ padding: "16px" }}>
          {file && filesIni !== undefined ? (
            <div className="uploads">
              <img
                className="bannerUpload"
                src={
                  filesIni
                    ? generateFileUrl(file.newName ? file.newName : file)
                    : URL.createObjectURL(file)
                }
              />
              <div>
                {currentUser.isAdmin && (
                  <Button variant="outlined" className="custom_mui_action" onClick={handleOnDelete}>
                    Excluir Logo
                  </Button>
                )}
              </div>
            </div>
          ) : (
            <div>
              <input type="file" multiple onChange={handleOnChange} hidden accept="image/png, image/jpeg" ref={inputRef} />
              <Button variant="outlined" className="custom_mui_action" onClick={handleOnclick}>
                Selecione o logo
              </Button>
            </div>
          )}
        </div>
        <div className="cust-fields cust-fields-3">
          <div className="cust-field">
            <label className="cust-label">Nome</label>
            <input type="text" name="name" defaultValue={company ? company.name || "" : ""} className="cust-input" onChange={handleChange} maxLength="200" ref={inputRefname} />
          </div>
          <div className="cust-field">
            <label className="cust-label">CNPJ</label>
            <input type="text" pattern="\d*" name="cnpj_cpf" className="cust-input" defaultValue={cnpj_cpf ? cnpj_cpf : ""} onChange={handleChangeCNPJ} maxLength="14" />
          </div>
          <div className="cust-field">
            <label className="cust-label">Razão Social</label>
            <input type="text" name="rzSocial" className="cust-input" onChange={handleChangeRz} defaultValue={rzSocial ? rzSocial : ""} maxLength="200" />
          </div>
        </div>
      </div>

      {/* Contato */}
      <div className="cust-card">
        <div className="cust-section-header">Contato</div>
        <div className="cust-fields cust-fields-3">
          <div className="cust-field">
            <label className="cust-label">Telefone</label>
            <input type="text" name="contact" onChange={handleChangeContact} className="cust-input" defaultValue={contact ? contact : ""} maxLength="12" />
          </div>
          <div className="cust-field">
            <label className="cust-label">Email</label>
            <input type="email" name="email" className="cust-input" defaultValue={company ? company.email || "" : ""} onChange={handleChange} maxLength="200" ref={inputRefemail} />
          </div>
        </div>
      </div>

      {/* Endereço */}
      <div className="cust-card">
        <div className="cust-section-header">Endereço</div>
        <div className="cust-fields cust-fields-3">
          <div className="cust-field">
            <label className="cust-label">CEP</label>
            <input type="text" pattern="\d*" name="cep" onChange={handleChangeCEP} className="cust-input" value={cep || ""} maxLength="8" />
          </div>
          <div className="cust-field">
            <label className="cust-label">Endereço</label>
            <input type="text" name="street" onChange={handleChangeStreet} className="cust-input" value={street || ""} maxLength="200" />
          </div>
          <div className="cust-field">
            <label className="cust-label">Número</label>
            <input type="text" name="numAddress" onChange={handleChangeNumAddress} className="cust-input" value={numAddress || ""} maxLength="8" />
          </div>
          <div className="cust-field">
            <label className="cust-label">Complemento</label>
            <input type="text" name="complement" onChange={handleChangeComplement} className="cust-input" value={complement || ""} maxLength="100" />
          </div>
          <div className="cust-field">
            <label className="cust-label">Estado</label>
            <select className="cust-select" name="state" value={state || ""} onChange={handleChangeState}>
              <option value=""></option>
              {states ? states.map((item) => (<option key={item.stateId} value={item.stateId}>{item.state}</option>)) : false}
            </select>
          </div>
          <div className="cust-field">
            <label className="cust-label">Cidade</label>
            <input type="text" name="city" onChange={handleChangeCity} className="cust-input" value={city || ""} maxLength="100" />
          </div>
        </div>
      </div>

      {/* Conteúdo */}
      <div className="cust-card">
        <div className="cust-section-header">Conteúdo</div>
        <div className="cust-fields">
          <div className="cust-field">
            <label className="cust-label">Sobre a Marca</label>
            <textarea rows="10" type="text" name="about" className="cust-textarea" defaultValue={company ? company.about : ""} onChange={handleChange} maxLength="5000" ref={inputRefabout} />
          </div>
          <div className="cust-field">
            <label className="cust-label">Política de Troca</label>
            <textarea rows="10" type="text" name="exchangePolicy" className="cust-textarea" defaultValue={company ? company.exchangePolicy : ""} onChange={handleChange} maxLength="5000" ref={inputRefPolicy} />
          </div>
        </div>
      </div>

      {/* Configurações */}
      <div className="cust-card">
        <div className="cust-section-header">Configurações</div>
        <div className="cust-fields cust-fields-3">
          <div className="cust-field">
            <label className="cust-label">Qtde mínima de produtos</label>
            <input type="text" name="minProducts" onChange={handleChange} className="cust-input" defaultValue={company && company.configRules ? company.configRules.minProducts || "" : ""} maxLength="8" ref={inputRefMinprd} />
          </div>
          <div className="cust-field">
            <label className="cust-label">Valor mínimo do pedido</label>
            <input type="text" name="minVlrOrder" onChange={handleChange} className="cust-input" defaultValue={company && company.configRules && company.configRules.minVlrOrder ? formatPricing(company.configRules.minVlrOrder) || "" : ""} maxLength="8" ref={inputRefMinOrder} />
          </div>
          <div className="cust-field">
            <label className="cust-label">Validar estoque no carrinho</label>
            <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <input type="checkbox" checked={validateStock} onChange={(e) => setValidateStock(e.target.checked)} />
              <span>{validateStock ? "Ligado (reduz qtde / remove por estoque)" : "Desligado (mantém o carrinho como está)"}</span>
            </label>
          </div>
        </div>
      </div>

      <div className="cust-footer">
        {currentUser.isAdmin && (
          <Button
            variant="contained"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={updateClick}
            size="small"
          >
            Salvar
          </Button>
        )}
      </div>

    </div>
  );
}
